export function getFeedbackCommentSidebarVisibilityOnStart({ commentCount, showComments }) {
  if (commentCount > 0) return true;
  if (showComments) return false;
  return showComments;
}

export function shouldOpenCommentSidebarForFirstFeedbackComment({
  hasAccessToCleanCopy,
  waitingForFeedbackComments,
  previousCommentCount,
  commentCount,
  showComments,
}) {
  if (!hasAccessToCleanCopy) return false;
  if (!waitingForFeedbackComments) return false;
  if (previousCommentCount > 0 || commentCount === 0) return false;
  return !showComments;
}
